/**
 * CCMS configuration constants
 */

/**
 * Current CCMS bucket version
 * When migrating to a new bucket, update this constant
 */
export const CCMS_BUCKET = sessionStorage.getItem("ccms_selected_version") || import.meta.env.REACT_APP_CCMS_VERSION;
export const CCMS_BASE_URL = `https://ccmsfiles.tg.org.au/${CCMS_BUCKET}`;

export const IDB_KEY_LENGTH = parseInt(import.meta.env.REACT_APP_IDB_KEY_LENGTH) || 17512;
console.log("CCMS IDB_KEY_LENGTH:", IDB_KEY_LENGTH, typeof IDB_KEY_LENGTH);